api = require('../api.coffee').api()

class global.FlowsResource extends ResourceBase
  @MODEL = Flow
  @SINGULAR_RESOURCE_NAME = 'flow'
  @PLURAL_RESOURCE_NAME = 'flows'

  constructor: (company_id) ->
    @company_id = company_id

  index: (success, failure, params = {}) ->
    api.get "/companies/#{@company_id}/flows", params, { success: @collectionSuccess(success), failure: @collectionFailure(failure) }

  create: (success, failure, params = {}) ->
    api.post "/companies/#{@company_id}/flows", params, { success: @memberSuccess(success), failure: failure }

  retry: (success, failure, params = {}) ->
    api.post "/flows/#{@getParamsId(params)}/retry", params, { success: @memberSuccess(success), failure: failure }

  get: (success, failure, params = {}) ->
    api.get "/flows/#{@getParamsId(params)}", params, { success: @memberSuccess(success), failure: failure }

  update: (success, failure, params = {}) ->
    api.put "/flows/#{@getParamsId(params)}", params, { success: @memberSuccess(success), failure: failure }

  destroy: (success, failure, params = {}) ->
    api.delete "/flows/#{@getParamsId(params)}", params, { success, failure }

  flow_reports: (success, failure, params = {}) ->
    console.log(params)
    api.get "/flows/#{@getParamsId(params.params)}/flow_reports", params, { success, failure }

  memberSuccess: (callback) ->
    (response) =>
      return unless callback
      flow_attributes = @cleanUpMemberResponseBody response.body.flow
      callback flow: new Flow flow_attributes

  collectionSuccess: (callback) ->
    (response) =>
      return unless callback
      flows = for flow_attributes in @cleanUpCollectionResponseBody response.body.flows
        new Flow flow_attributes

      callback flows: flows, meta: response.body.meta

  collectionFailure: (failure_callback) ->
    (response) ->
      failure_callback(response) if failure_callback

  cleanUpMemberResponseBody: (flow_attributes) ->
    recipients = flow_attributes.recipients || []
    delete flow_attributes.recipients

    flow_attributes.contacts = for recipient in recipients
      delete recipient.contact.flow
      contact_attributes = recipient.contact
      delete recipient.contact
      contact_attributes.recipient = recipient
      contact_attributes

    flow_attributes

  cleanUpCollectionResponseBody: (flows_attributes) ->
    @cleanUpMemberResponseBody(flow_attributes) for flow_attributes in flows_attributes

  reengage: (success, failure, params = {}) ->
    api.post "/flows/#{@getParamsId(params)}/reengage",
      params, {
        success: @memberSuccess(success),
        failure: failure
      }



// WEBPACK FOOTER //
// ./src/resources/flows.coffee